import React, {Fragment} from 'react';
import {v4 as uuidV4} from "uuid";

const Options = (props) => {
  const accountsData = props.accountsData.map(v => {
    const row = {}
    row.label = v.label
    row.value = v.value
    return row
  })
  try {
    return <>
      {accountsData.map((row, index) => {
        return <Fragment  key={uuidV4()}>
          <option key={uuidV4()} value={row.value}>{row.value}-{row.label}</option>
        </Fragment>
      })}
    </>
  } catch (error) {
    return <>{error.toString()}</>
  }
}

export default React.memo(Options);